export default {
  computed: {
    tourIsEnabled () {
      return process.env.VUE_APP_ENABLE_TOUR === 'true'
    }
  },
  methods: {
    async fetchAllTours () {
      this.isLoading = true
      await this.$store
        .dispatch('appTour/fetchAllTours')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          this.$notify({
            title: this.httpErrorMessage.customMessage,
            message: err || '',
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
